import { useParams, Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock, ArrowRight, Share2 } from "lucide-react";
import { toast } from "sonner";
import Navbar from "../components/Navbar";
import { getTab, shareLook } from "../lib/tryOnData";

export default function LookPreview() {
  const { category } = useParams();
  const navigate = useNavigate();
  const tab = getTab(category);

  if (!tab) {
    navigate("/try-on", { replace: true });
    return null;
  }

  const onShare = async () => {
    const r = await shareLook(tab.key, tab.label);
    if (r.copied) toast.success("Link copied — paste it anywhere.");
  };

  return (
    <div className="relative z-10 min-h-screen">
      <Navbar />
      <div className="px-6 md:px-16 py-12 md:py-16 max-w-5xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
            className="max-w-sm mx-auto w-full"
          >
            <img
              src={tab.after}
              alt={tab.label}
              data-testid="look-image"
              className="w-full aspect-[3/4] object-cover object-top rounded-[14px] ring-1 ring-[#1A1A1A]/10 shadow-[0_40px_90px_-30px_rgba(26,20,15,0.5)]"
            />
          </motion.div>

          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-[#F4F1EA] border border-[#1A1A1A]/10 px-4 py-1.5 text-xs uppercase tracking-[0.3em] text-[#6D214F] mb-5">
              <Clock className="w-3.5 h-3.5" /> Launching December 2026
            </span>
            <p className="text-xs uppercase tracking-[0.4em] text-[#8B5A2B] mb-3">{tab.label}</p>
            <h1 className="font-serif-display text-4xl md:text-5xl leading-tight text-[#1A1A1A]">
              See yourself in vintage.
            </h1>
            <div className="w-16 h-px bg-[#1A1A1A]/20 my-6" />
            <p className="text-base text-[#4A4A4A] leading-relaxed max-w-md">{tab.copy}</p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to={`/try-on?c=${tab.key}`}
                data-testid="look-join-waitlist"
                className="inline-flex items-center justify-center gap-2 bg-[#1A1A1A] text-[#FDFBF7] px-7 py-3.5 rounded-full hover:bg-[#6D214F] transition-colors duration-300"
              >
                Join the waitlist <ArrowRight className="w-4 h-4" />
              </Link>
              <button
                onClick={onShare}
                data-testid="look-share"
                className="inline-flex items-center justify-center gap-2 border border-[#1A1A1A]/20 px-7 py-3.5 rounded-full hover:border-[#6D214F] hover:text-[#6D214F] transition-colors duration-300"
              >
                <Share2 className="w-4 h-4" /> Share
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
